import React from "react";

interface IconProps {
  fill?: string;
  height?: string;
}

const Success = (props: IconProps): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96.25"
    fill={props.fill || "#0071B9"}
    height={props.height || "16px"}
  >
    <title>Success</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Success">
          <path d="M94.647,15.723l-0.157,0.182l-0.003-0.003L49.53,68.086c-0.76,0.883-1.866,1.39-3.03,1.39c-0.007,0-0.014,0-0.021,0&#10;&#9;c-1.171-0.006-2.282-0.526-3.037-1.422L29.004,50.929l0.003-0.003l-0.003,0.003c-1.377-1.634-2.038-3.707-1.855-5.839&#10;&#9;c0.18-2.129,1.183-4.058,2.818-5.431l5.151,6.116l0.003-0.002l11.412,13.536l42.052-48.812l0.001,0.001&#10;&#9;c1.442-1.672,3.965-1.859,5.638-0.418C95.897,11.521,96.089,14.049,94.647,15.723z M92.675,35.462l-1.307-4.506l-6.401,6.648&#10;&#9;C85.67,40.05,85.985,42.131,85.985,48c0,20.953-17.047,38-38,38s-38-17.047-38-38s17.047-38,38-38c9.213,0,18.236,3.333,25.41,9.386&#10;&#9;l5.158-6.114C69.939,6.003,59.083,2,47.985,2c-25.364,0-46,20.636-46,46s20.636,46,46,46s46-20.636,46-46&#10;&#9;C93.985,41.919,93.677,38.97,92.675,35.462z" />
        </g>
      </g>
    </g>
  </svg>
);

export default Success;
